@if (visible) {
  <div role="status" class="flex flex-col rounded-card bg-vw-warn-bg px-3 pt-2 text-body-s text-vw-warn-ink" data-test="offline-banner">
    <p class="flex items-center gap-2 font-semibold">
      <!-- Nuage barré, comme l'état d'erreur : la liaison est coupée, pas le jardin -->
      <svg class="h-5 w-5 shrink-0" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5"
        stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">
        <path d="M2 2l20 20" />
        <path d="M5.8 5.8A7 7 0 0 0 7 19h10.5" />
        <path d="M21.5 15.6A4.5 4.5 0 0 0 17.5 9h-1.8A7 7 0 0 0 9.6 5.3" />
      </svg>
      {{ titleKey | translate: params }}
    </p>
    <div class="flex items-center justify-between gap-2">
      <p class="min-w-0">{{ messageKey | translate: params }}</p>
      <!-- 44 px : la cible se touche avec un doigt -->
      <button type="button" class="min-h-target shrink-0 rounded-pill px-2 font-semibold underline" (click)="retry.emit()">
        {{ 'components.error-state.retry' | translate }}
      </button>
    </div>
  </div>
}
